import React, { useState } from 'react';
import { LogOut, MessageSquarePlus, Sparkles } from 'lucide-react';
import apiService from '../../services/apiService';
import { useI18n } from '../../utils/i18n';
import { disablePushSubscription } from '../../utils/pushManager';
import Modal from '../ui/Modal';
import ReleaseNotesModal from '../ReleaseNotesModal';
import FeedbackModal from '../FeedbackModal';
import DarstellungWahl from '../einstellungen/DarstellungWahl';
import './mobil.css';

// Einstellungen der Mobilansicht, als unten angedocktes Sheet (ui/Modal).
// Aus dem Zahnrad-Menü des Desktop-Headers nur, was am Handy Sinn hat:
// Sprache, "Was ist neu?", Feedback und Abmelden. API-Keys, Kunden und
// Administration bleiben am Arbeitsplatz. #567: dazu die Darstellung, derselbe
// Baustein wie im Einstellungs-Dialog des Arbeitsplatzes.
const MobilEinstellungen = ({ offen, onClose, benutzer }) => {
  const { t, lang, setLanguage } = useI18n();
  const [neuigkeiten, setNeuigkeiten] = useState(false);
  const [feedback, setFeedback] = useState(false);
  const [meldetAb, setMeldetAb] = useState(false);

  const name = benutzer?.displayName || benutzer?.mail || benutzer?.userPrincipalName || '';

  const abmelden = async () => {
    setMeldetAb(true);
    // Wie im Header (#16 B6): Gerät von Push abmelden, sonst kämen
    // Benachrichtigungen ohne Sitzung weiter an.
    try { await disablePushSubscription(); } catch (_) {
      // Ohne Push-Abo gibt es nichts abzumelden.
    }
    try { await apiService.logout(); } catch (_) {
      // Auch bei einem Fehler zur Startseite; die Sitzung prüft der Server.
    }
    window.location.href = '/';
  };

  return (
    <>
      <Modal open={offen} onClose={onClose} title={name || t('mobile.settings', 'Einstellungen')} ariaLabel={t('mobile.settings', 'Einstellungen')} maxWidth="480px">
        <div className="mobil-einstellungen">
          <label htmlFor="mobil-sprache" className="mobil-label">{t('mobile.language', 'Sprache')}</label>
          <select id="mobil-sprache" className="mobil-einstellungen-sprache" value={lang} onChange={(e) => setLanguage(e.target.value)}>
            <option value="de">{t('language.de', 'Deutsch')}</option>
            <option value="en">{t('language.en', 'Englisch')}</option>
            <option value="es">{t('language.es', 'Spanisch')}</option>
          </select>

          <span className="mobil-label">{t('einstellungen.darstellung', 'Darstellung')}</span>
          <DarstellungWahl idPraefix="mobil" />

          <button type="button" className="mobil-einstellungen-punkt" onClick={() => { onClose(); setNeuigkeiten(true); }}>
            <Sparkles size={20} aria-hidden="true" />
            <span>{t('header.whatsNew', 'Was ist neu?')}</span>
          </button>
          <button type="button" className="mobil-einstellungen-punkt" onClick={() => { onClose(); setFeedback(true); }}>
            <MessageSquarePlus size={20} aria-hidden="true" />
            <span>{t('mobile.sendFeedback', 'Feedback senden')}</span>
          </button>
          <button type="button" className="btn btn-secondary mobil-touch mobil-einstellungen-abmelden" onClick={abmelden} disabled={meldetAb}>
            <LogOut size={18} aria-hidden="true" />
            <span>{t('header.logout', 'Abmelden')}</span>
          </button>
        </div>
      </Modal>
      <ReleaseNotesModal open={neuigkeiten} onClose={() => setNeuigkeiten(false)} />
      <FeedbackModal isOpen={feedback} onClose={() => setFeedback(false)} />
    </>
  );
};

export default MobilEinstellungen;
